import { MasqueradeBanner } from "@circle-react/components/MasqueradeBanner";
import { RailsFlashMessages } from "@circle-react/components/RailsFlashMessages";

import { OptInBar } from "@/react/components/NewVersionOptIn/OptInBar";
import { PreviewBar } from "@/react/components/NewVersionOptIn/PreviewBar";
import { ErrorBoundary } from "@/react/components/shared/ErrorPages/ErrorBoundary";
import { useContentProps } from "@/react/providers/MainApp/ContentPropsProvider";

export const ShellChromeBanners = () => {
  const { notice, alert } = useContentProps();
  return (
    <ErrorBoundary>
      <RailsFlashMessages notice={notice} alert={alert} />
      <PreviewBar />
      <OptInBar />
      <MasqueradeBanner />
    </ErrorBoundary>
  );
};
